import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ReportMonthPage } from './report-month';

@NgModule({
  declarations: [
    ReportMonthPage,
  ],
  imports: [
    IonicPageModule.forChild(ReportMonthPage),
  ],
})
export class ReportMonthPageModule {}



// WEBPACK FOOTER //
// ./src/pages/report-month/report-month.module.ts